const types = {
    STORE_FILTERS: 'STORE_FILTERS',
    REMOVE_FILTER: 'REMOVE_FILTER',
    REMOVE_ALL: 'REMOVE_ALL'
}

export default types;

export const storeFilters = (filters) => {
    return { type: types.STORE_FILTERS, payload: { filters } };
}

export const removeFilter = (id) => {
    return { type: types.REMOVE_FILTER, payload: { id } };
}

export const removeAll = () => {
    return { type: types.REMOVE_ALL };
}